import React, { useEffect } from "react";
import * as Scrivito from "scrivito";
import { ObjValidator } from "components";

import { WizardMainWrapper } from "objs/_ConfiguratorObjs/Wizard/SubComponents/WizardMainWrapper";
import { FeatureUnavailable } from "components/FeatureUnavailable";

import { useUrqlContext } from "providers";
import {
  useWizardActions,
  useSubType,
  useIsFetching,
} from "stores/wizardStore";
import { useLanguage } from "stores/globalStore";
import { useCheckIsWizardEnabled } from "hooks/wizardHooks/useEnabledWizardObjs";

const Wizard = Scrivito.connect(() => {
  const {
    projectId,
    nodeId,
    subType: subTypeParam,
    step,
  } = Scrivito.currentPageParams();
  const lang = useLanguage();
  const { client } = useUrqlContext();
  const { getWizardData, setInitialState, resetState } = useWizardActions();
  const subTypeStore = useSubType();
  const isFetching = useIsFetching();

  const subType = subTypeParam || subTypeStore;

  const checkIsWizardEnabled = useCheckIsWizardEnabled();
  const isPageEnabled = checkIsWizardEnabled(subType);

  useEffect(() => {
    setInitialState({
      urqlClient: client,
      language: lang,
      projectId,
      nodeId,
      subType: subType,
      step: isNaN(Number(step)) ? null : Number(step),
    });

    if (nodeId && step !== 0) {
      getWizardData();
    }
    return () => {
      resetState();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (subType && !isPageEnabled && !isFetching) {
    return <FeatureUnavailable />;
  }

  return <WizardMainWrapper />;
});

const CheckedPage = (props) => {
  return (
    <ObjValidator {...props}>
      <Wizard {...props} />
    </ObjValidator>
  );
};
export default CheckedPage;
Scrivito.provideComponent("Wizard", CheckedPage);
